import { useAppDispatch } from "app/hooks/hooks";
import axios from "axios";
import { getOutlet } from "redux/userList/userSlice";
import { GetLastUpdatedOutletListResponse } from "services/api/types";

const useGetOutlet = () => {
	const dispatch = useAppDispatch();

	const getOutletData = async (outletCode: string) => {
		try {
			const resultAction = await dispatch(getOutlet({ outlet_code: outletCode }));
			const response = resultAction.payload;

			if (!response) {
				throw new Error("Failed to get outlet");
			}

			if (axios.isAxiosError(response)) {
				const { errors } = response?.response?.data as GetLastUpdatedOutletListResponse;
				throw new Error(errors[0].code);
			}

			return response;
		} catch (error) {
			throw new Error(error instanceof Error ? error.message : String(error));
		}
	};

	return { getOutletData };
};

export default useGetOutlet;
